import { applicationIncomeApi } from 'app/services/api';
import { normalize, schema } from 'normalizr';

import { LOAN_APPLICATION_ACTION_NAME_PREFIX } from 'constants/loanApplication';
import { catchAsyncActionError } from 'utils/action';
import { createNamedActions } from 'utils/namedActionTypesProxy';

export const INCOME_AND_EMPLOYMENT_ACTION_TYPE = createNamedActions(
  // LOAN_APPLICATION_ACTION_NAME_PREFIX is used for Redux Middleware in Loan Editor
  `${LOAN_APPLICATION_ACTION_NAME_PREFIX}/incomeAndEmployment`,
  {
    GET_INCOMES: 'GET_INCOMES',
    DELETE_LOAN_APPLICATION_INCOME: 'DELETE_LOAN_APPLICATION_INCOME',
  },
);

const incomesSchema = new schema.Entity('data', {}, { idAttribute: 'incomeId' });

export const getApplicationIncomesAction = catchAsyncActionError(params => async dispatch => {
  const { data } = await applicationIncomeApi.getIncomes(params);

  return dispatch({
    type: INCOME_AND_EMPLOYMENT_ACTION_TYPE.GET_INCOMES,
    payload: normalize(data, [incomesSchema]).entities.data,
  });
});

export const deleteLoanApplicationIncomeAction = catchAsyncActionError(params => async dispatch => {
  const { incomeId } = params;

  const { data } = await applicationIncomeApi.deleteIncome(params);

  return dispatch({
    type: INCOME_AND_EMPLOYMENT_ACTION_TYPE.DELETE_LOAN_APPLICATION_INCOME,
    payload: data,
    meta: { incomeId },
  });
});
